/**
 * @generated SignedSource<<b518fc88613c162cfa97bd29f7198884>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvitePanel_Session$data = {
  readonly currentClientProfile: {
    readonly __typename: string;
    readonly member: {
      readonly club: {
        readonly name: string;
        readonly slug: string;
        readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"SignInFooter_session">;
  readonly " $fragmentType": "InvitePanel_Session";
};
export type InvitePanel_Session$key = {
  readonly " $data"?: InvitePanel_Session$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvitePanel_Session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvitePanel_Session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SignInFooter_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ClubLogo_Club"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "e614682837a6dd5179aeeddb9f6c61de";

export default node;
